export function ErrorMessage({ children }) {
  return <div className="text-danger small">{children}</div>;
}
